import i18next from 'i18next';
import { printValue } from 'yup';

function getFieldName(path) {
  return i18next.exists(path) ? i18next.t(path) : 'Detta fält';
}

export default {
  mixed: {
    default: ({ path }) => `${getFieldName(path)} är ogiltigt`,
    required: ({ path }) => `${getFieldName(path)} är ett obligatoriskt fält`,
    defined: ({ path }) => `${getFieldName(path)} måste definieras`,
    notNull: ({ path }) => `${getFieldName(path)} kan inte vara null`,
    oneOf: ({ path, values }) =>
      `${getFieldName(path)} måste vara ett av följande värden: ${i18next.t(values)}`,
    notOneOf: ({ path, values }) =>
      `${getFieldName(path)} får inte vara ett av följande värden: ${i18next.t(values)}`,
    notType: ({ path, type, value, originalValue }) => {
      const isCast = originalValue != null && originalValue !== value;
      let msg =
        `${getFieldName(path)} måste vara en \`${i18next.t(type)}\` typ, ` +
        `men det slutliga värdet var: \`${printValue(value, true)}\`` +
        (isCast
          ? ` (konverterad från värdet \`${printValue(originalValue, true)}\`).`
          : '.');

      if (value === null) {
        msg +=
          `\n Om "null" är avsett som ett tomt värde, se till att markera schemat som` +
          ' `.nullable()`';
      }

      return msg;
    },
  },
  string: {
    length: ({ path, length }) =>
      `${getFieldName(path)} måste vara exakt ${length} tecken`,
    min: ({ path, min }) =>
      `${getFieldName(path)} måste vara minst ${min} tecken`,
    max: ({ path, max }) =>
      `${getFieldName(path)} får vara högst ${max} tecken`,
    matches: ({ path, regex }) =>
      `${getFieldName(path)} måste matcha följande: "${regex}"`,
    email: ({ path }) =>
      `${getFieldName(path)} måste vara en giltig e-postadress`,
    url: ({ path }) => `${getFieldName(path)} måste vara en giltig URL`,
    uuid: ({ path }) => `${getFieldName(path)} måste vara en giltig UUID`,
    trim: ({ path }) => `${getFieldName(path)} måste vara en trimmad sträng`,
    lowercase: ({ path }) =>
      `${getFieldName(path)} måste vara en sträng med gemener`,
    uppercase: ({ path }) =>
      `${getFieldName(path)} måste vara en sträng med versaler`,
  },
  number: {
    min: ({ path, min }) =>
      `${getFieldName(path)} måste vara större än eller lika med ${min}`,
    max: ({ path, max }) =>
      `${getFieldName(path)} måste vara mindre än eller lika med ${max}`,
    lessThan: ({ path, less }) =>
      `${getFieldName(path)} måste vara mindre än ${less}`,
    moreThan: ({ path, more }) =>
      `${getFieldName(path)} måste vara större än ${more}`,
    positive: ({ path }) => `${getFieldName(path)} måste vara ett positivt tal`,
    negative: ({ path }) => `${getFieldName(path)} måste vara ett negativt tal`,
    integer: ({ path }) => `${getFieldName(path)} måste vara ett heltal`,
  },
  date: {
    min: ({ path, min }) =>
      `${getFieldName(path)} fält måste vara senare än ${min}`,
    max: ({ path, max }) =>
      `${getFieldName(path)} fält måste vara tidigare än ${max}`,
  },
  object: {
    noUnknown: ({ path, unknown }) =>
      `${getFieldName(path)} fält har ospecificerade nycklar: ${i18next.t(unknown)}`,
  },
  array: {
    min: ({ path, min }) =>
      `${getFieldName(path)} fält måste ha minst ${min} objekt`,
    max: ({ path, max }) =>
      `${getFieldName(path)} fält måste ha högst ${max} objekt`,
    length: ({ path, length }) =>
      `${getFieldName(path)} måste ha ${length} objekt`,
  },
  boolean: {
    isValue: ({ path, value }) =>
      `${getFieldName(path)} fält måste vara ${i18next.t(value)}`,
  },
};
